export const GLOBAL_STATE = 'ChatGroup'

export const CHAT_GROUP_CREATE = 'CHAT_GROUP_CREATE'
export const CHAT_GROUP_BY_COMPONENT = 'CHAT_GROUP_BY_COMPONENT'
export const CHAT_GROUP_BY_ID = 'CHAT_GROUP_BY_ID'
export const CHAT_GROUP_DEACTIVATE = 'CHAT_GROUP_DEACTIVATE'
export const MESSAGES_GROUP = 'MESSAGES_GROUP'
export const MESSAGES_GROUP_ALL = 'MESSAGES_GROUP_ALL'
